import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import { pascalCase } from '../utility/functions';

const Wrapper = styled.label`
    display: flex;
    gap: 0.5em;
    align-items: baseline;
    box-sizing: border-box;
    color: ${({ theme }) => theme.text};
    font-weight: bold;
    font-size: ${({ fontSize = 1 }) => fontSize}em;
`;
const I = styled(Icon)`
    margin-right: 0.5em;
`;

const Heading = ({ children, ...props }) => (
    <Wrapper {...props}>
        {props.icon && !props.right ? <I icon={props.icon} /> : null}
        {typeof props.label === 'string' || typeof children === 'string' ? pascalCase(props.label || children) : children}
        {props.icon && props.right ? <I icon={props.icon} /> : null}
    </Wrapper>
);

export default Heading;